import React, { useState, useEffect } from 'react';
import { RespResumeOtherAttachment } from '../../../item/ItemResume';
import { api_upload_file } from '../../../api/apiUpload';
import Swal from 'sweetalert2';
import { SearchButton, DeleteButton } from './BaseButton';
import { loginPageInfo, URL_UPLOAD_ALL, URL_UPLOAD_FILE } from '../../../config';
import { SingleInput } from './BaseInput';

export function AttachmentItems({ parameter, index, attachment, setAttachment, isEdit, uploadAll=false }) {
    const [mAttachment, setA] = useState(new RespResumeOtherAttachment({}))
    const [filePath, setFilePath] = useState("")
    const [fileName, setFileName] = useState("")
    const [fileType, setFileType] = useState("")
    const [note, setNote] = useState("")
    const [creatAt, setCreatAt] = useState("")

    const [file, setFile] = useState()

    useEffect(() => {
        if (attachment !== undefined && attachment !== mAttachment) {
            setAll(attachment)
        }
    }, [attachment])

    function setAll(attachment) {
        setA(attachment)
        setFilePath(attachment.filePath)
        setFileName(attachment.fileName)
        setFileType(attachment.fileType)
        setNote(attachment.note)
        setCreatAt(attachment.creatAt)
    }

    function init() {
        var mRespResumeOtherAttachment = new RespResumeOtherAttachment({})
        setAll(mRespResumeOtherAttachment)
        //console.log(mRespResumeOtherAttachment)
        //console.log(index)
        setAttachment(index, mRespResumeOtherAttachment)
    }

    function sN(val) {
        //console.log(val)
        setNote(val)
        var mRespResumeOtherAttachment = new RespResumeOtherAttachment({
            filePath,
            fileName,
            fileType,
            note: val,
            creatAt,
        })
        //console.log(mRespResumeOtherAttachment)
        setAttachment(index, mRespResumeOtherAttachment)
    }

    function del() {
        setFilePath("")
        setFileName("")
        setFileType("")
        setCreatAt("")
        setFile(undefined)
    }

    function upload() {
        if (file === undefined) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "您沒有選擇檔案",
            })
            return
        }
        api_upload_file({
            file,
            uploadPath:uploadAll?URL_UPLOAD_ALL:URL_UPLOAD_FILE,
            success: (jsonData) => {
                console.log(jsonData)
                var mRespResumeOtherAttachment = new RespResumeOtherAttachment({})
                mRespResumeOtherAttachment.fromJson(jsonData.info)
                mRespResumeOtherAttachment.note = note
                setAll(mRespResumeOtherAttachment)
                setAttachment(index, mRespResumeOtherAttachment)
            },
            failure: (err) => {
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                })
            }
        })
    }

    var uploadBox =
        <>
            {(fileName === "" || fileName === undefined) ?
                <>
                    <div className="col-md-3">
                        <input className="btn" type="file" name="file" accept="" onChange={e => setFile(e.target.files[0])} />
                    </div>
                    <div className="col-md-2">
                        <SearchButton name="上傳" action={upload} icon={""} />
                    </div>
                </>
                :
                <>
                    <div className="col-md-3">
                        <p className="text-success">
                            <a href={loginPageInfo.getServerUrl() + filePath} target="_blank" >{fileName}</a>
                        </p>
                    </div>
                    <div className="col-md-2">
                        <DeleteButton action={del} />
                    </div>
                </>
            }
            {parameter.editInfo ? <SingleInput val={note} action={sN} placeholder={"可填寫備註"} size={5} /> : <></>}
        </>

    var detailBox = <>
        {
            (fileName === "" || fileName === undefined) ?
                <div className="col-md-6 text-muted">未上傳</div>
                :
                <>
                    <div className="col-md-6">
                        <p className="text-success">
                            <a href={loginPageInfo.getServerUrl() + filePath} target="_blank" >{fileName}</a>
                        </p>
                    </div>
                </>
        }
    </>
    return (
        <>
            {parameter.br ? <div className="hr-line-dashed"></div> : <div className="m-t-sm"></div>}
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-2 m-t-sm">
                        <p>{parameter.name}</p>
                    </div>
                    {isEdit ? uploadBox : detailBox}
                </div>
            </div>
        </>
    )
}
